import React from 'react'
import './TableSelectCheckbox.css'

/**
 * A reusable checkbox component for table row selection.
 * Used in tables to select individual rows or all rows.
 * 
 * @param {boolean} checked - Whether the checkbox is checked
 * @param {function} onChange - Callback when checkbox state changes
 * @param {boolean} isHeader - Whether this is a header checkbox (for select all)
 */
function TableSelectCheckbox({ checked, onChange, isHeader = false }) {
  const handleClick = (e) => {
    e.stopPropagation()
    onChange()
  }

  return (
    <div 
      className={`table-select-cell ${isHeader ? 'header' : ''}`} 
      onClick={handleClick}
    >
      <input
        type="checkbox"
        className="table-select-checkbox"
        checked={checked}
        onChange={() => {}} // Handled by onClick on parent div
        readOnly
      />
    </div>
  )
}

export default TableSelectCheckbox

